var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRmpDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 652,
    height: 184,
    viewBox: "0 0 652 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488.5 0H165.5V161H488.5V0Z",
    fill: "#F4F7FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M487.5 0H601V161H487.5V0Z",
    fill: "#D5E3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 0H165V161H51V0Z",
    fill: "#D5E3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M601 0H651V161H601V0Z",
    fill: "#2D72FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1 0H51V161H1V0Z",
    fill: "#2D72FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M327 169H325V184H327V169Z",
    fill: "#D3D3D3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M489 172H488V181H489V172Z",
    fill: "#D3D3D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M602 174H601V179H602V174Z",
    fill: "#D3D3D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165 172H164V181H165V172Z",
    fill: "#D3D3D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51 174H50V179H51V174Z",
    fill: "#D3D3D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M650.5 176.25H1.5C1.36193 176.25 1.25 176.362 1.25 176.5C1.25 176.638 1.36193 176.75 1.5 176.75H650.5C650.638 176.75 650.75 176.638 650.75 176.5C650.75 176.362 650.638 176.25 650.5 176.25Z",
    fill: "#D3D3D3",
    stroke: "#D3D3D3",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M651 160.501C651 160.501 546.5 161.006 508.5 140.501C432.5 99.4912 381.5 0.500977 326 0.500977C270.5 0.500977 218.508 101 133.5 143.501C104.5 158 1 160.501 1 160.501",
    stroke: "#0149DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmpDiagram);
export default __webpack_public_path__ + "static/media/rmp-diagram.5d46ae148da3eac4ad76f47b4beed080.svg";
export { ForwardRef as ReactComponent };